import classes from './lineloading.module.css'
const Lineloading = () => {
    return (
        <div className= 'loadingContainer' > 
            <div className={classes.loading}></div>
        </div>
    )
}

export default Lineloading
